/**
 * The ONLY module that reads Vite's `import.meta.env` — everything else imports these
 * constants instead.
 *
 * Why: the app's Jest setup (@swc/jest → CommonJS) cannot parse `import.meta`, so any
 * test whose import graph reached a file reading it failed to LOAD (e.g. via
 * services/currentUser → sentry.ts), silently killing whole suites. jest.config.frontend.js
 * maps this module to ./viteEnv.jest.ts instead.
 *
 * Keep each read written literally as `import.meta.env.X` so Vite still replaces it
 * statically at build time.
 */
export const IS_DEV: boolean = import.meta.env.DEV;
export const IS_PROD: boolean = import.meta.env.PROD;
export const GIT_SHA: string | undefined = import.meta.env.GIT_SHA;
export const PUBLIC_URL: string | undefined = import.meta.env.PUBLIC_URL;
